
import api from '@/service/api';
import store from '@/store';
import SessionsModule from '@/store/modules/Sessions';
import UserModule from '@/store/modules/User';
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import SingleSummary from './SingleSummary.vue';

const userModule = getModule(UserModule, store);
const sessionsModule = getModule(SessionsModule, store);

interface ClientData {
    linkCode: string;
    fullName: string;
    email: string;
    claimedAt: number;
    photographerComment: string;
}

@Component({
    components: {
        SingleSummary,
    }
})
export default class Summary extends Vue {
    clients: {
        [sessionId: string]: Array<ClientData>;
    } = {};
    search: string = '';
    isLoading: boolean = true;

    async mounted() {
        this.isLoading = true;
        try {
            this.clients = await api.getClients();
        } catch (error) {
            console.error('Error loading clients:', error);
        } finally {
            this.isLoading = false;
        }
    }

    get sessions() {
        return sessionsModule.sessionList[userModule.user!.id]
            .filter(({ id }) => Object.keys(this.clients).includes(id));
    }

    get hasClients() {
        return Object.keys(this.clients).some(sessionId => this.clients[sessionId].length > 0);
    }

    filteredClients(session: any) {
        if (!this.search) return this.clients[session.id] || [];
        const phrase = this.search.toLowerCase();
        // If session name matches, return all clients for this session
        if (session.name?.toLowerCase().includes(phrase)) {
            return this.clients[session.id] || [];
        }
        // Otherwise, filter clients
        return (this.clients[session.id] || []).filter(client => {
            return (
                client.fullName?.toLowerCase().includes(phrase) ||
                client.email?.toLowerCase().includes(phrase) ||
                (client.photographerComment || '').toLowerCase().includes(phrase)
            );
        });
    }

    get filteredSessions() {
        if (!this.search) {
            return this.sessions.filter(({ id }) => (this.clients[id] || []).length > 0);
        }
        // Only sessions with at least one matching client or session name
        return this.sessions.filter(session => this.filteredClients(session).length > 0);
    }
}
